import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'; 
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from './styles/GlobalStyles'; 
import theme from './styles/theme1'; 
import LoginScreen from './screens/LoginScreen';
import DashboardScreen from './screens/DashboardScreen';
import MyTaskPage from './screens/MyTaskPage';
import UploadFilePage from './screens/UploadFilePage';
import ListFormsPage from './screens/ListFormsPage';
import ScheduleTaskPage from './screens/ScheduleTaskPage';
import CreateUserPage from './screens/CreateUserPage';
import ForgotPasswordUserPage from './screens/ForgotPasswordUserPage';
import FormEditorPage from './screens/FormEditorPage';
import FillTaskFormPage from './screens/Filltaskform';
import SubmittedFormsListPage from './screens/SubmittedFormsListPage';
import ViewSubmittedFormPage from './screens/ViewSubmittedFormPage';
import DashboardLayout from './layouts/DashboardLayout';

function App() {
  return (
    // Use Material-UI's ThemeProvider here
    <MuiThemeProvider theme={theme}>
      <CssBaseline /> {/* Apply consistent baseline CSS from Material-UI */}
      <GlobalStyles /> {/* Your GlobalStyles from styled-components can still apply */}
      <Router>
        <Routes>
          <Route path="/login" element={<LoginScreen />} />

          {/* Protected routes wrapped by DashboardLayout */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardScreen />} />
            <Route path="my-task" element={<MyTaskPage />} />
            <Route path="task/:taskId" element={<FillTaskFormPage />} />            
            <Route path="form-management/upload" element={<UploadFilePage />} />
            <Route path="form-management/list" element={<ListFormsPage />} />
            <Route path="form-management/edit/:id" element={<FormEditorPage />} />
            <Route path="form-management/list-saved-forms" element={<SubmittedFormsListPage/>}/>
            <Route path="submitted-forms/view/:id" element={<ViewSubmittedFormPage/>}/>
            <Route path="schedule-task" element={<ScheduleTaskPage />} />
            <Route path="user-management/create" element={<CreateUserPage />} />
            <Route path="user-management/forgot-password" element={<ForgotPasswordUserPage />} />
          </Route>


          <Route path="*" element={<Navigate to="/login" replace/>} />
        </Routes>
      </Router>
    </MuiThemeProvider>
  );
}

export default App;